<template>
  <div class="content-wrapper">
    <h3 id="classes" class="size-4 fw-600 doc-section-title">
      <a href="#classes">#</a>Global Classes
    </h3>
    <div class="doc-table">
      <table>
        <thead>
          <th>Class</th>
          <th style="width: 70%">Description</th>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>no-shadow</code>
            </td>
            <td>
              Cancels shadow. Valid for all elements that have a shadow.
            </td>
          </tr>
          <tr>
            <td>
              <code>shadow-right</code>
            </td>
            <td>Turns the shadow to right.</td>
          </tr>
          <tr>
            <td>
              <code>shadow-top</code>
            </td>
            <td>Turns the shadow to top.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3 id="custom-properties" class="size-4 fw-600 doc-section-title">
      <a href="#custom-properties">#</a>Global Custom Properties
    </h3>
    <div class="doc-table">
      <table>
        <thead>
          <th>Property</th>
          <th style="width: 70%">Default</th>
        </thead>
        <tbody>
          <tr>
            <td>
              <code style="white-space: nowrap;">--black</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background: #000"></span>
                <code>#000</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--white</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background: #fff"></span>
                <code>#fff</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--gray-light</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background:  rgb(243, 243, 243)"
                ></span>
                <code>rgb(243, 243, 243)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--gray</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(196, 196, 196)"
                ></span>
                <code>rgb(196, 196, 196)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--gray-dark</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background:  rgb(97, 97, 97)"></span>
                <code>rgb(97, 97, 97)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--green-light</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background:rgb(214, 231, 218)"
                ></span>
                <code>rgb(214, 231, 218)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--green</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background:rgb(176, 233, 189)"
                ></span>
                <code>rgb(176, 233, 189)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--green-dark</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background:rgb(50, 136, 69)"></span>
                <code>rgb(50, 136, 69)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--yellow-light</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background:rgb(255, 244, 204)"
                ></span>
                <code>rgb(255, 244, 204)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--yellow</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(255, 231, 145)"
                ></span>
                <code>rgb(255, 231, 145)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--yellow-dark</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background: rgb(255, 199, 0)"></span>
                <code>rgb(255, 199, 0)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--orange-light</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background:rgb(246, 236, 217)"
                ></span>
                <code>rgb(246, 236, 217)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--orange</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background:rgb(240, 208, 146)"
                ></span>
                <code>rgb(240, 208, 146)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--orange-dark</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background:rgb(209, 161, 67)"></span>
                <code>rgb(209, 161, 67)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--blue-light</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background: rgb(211 235 255)"></span>
                <code>rgb(211 235 255)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--blue</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(176, 229, 233)"
                ></span>
                <code>rgb(176, 229, 233)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--blue-dark</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(50, 115, 220)"
                ></span>
                <code>rgb(50, 115, 220)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--purple-light</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(221, 220, 255)"
                ></span>
                <code>rgb(221, 220, 255)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--purple</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(187, 185, 255)"
                ></span>
                <code>rgb(187, 185, 255)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--purple-dark</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background: rgb(85, 81, 255)"></span>
                <code>rgb(85, 81, 255)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--pink-light</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(239, 218, 237)"
                ></span>
                <code>rgb(239, 218, 237)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--pink</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(233, 176, 227)"
                ></span>
                <code>rgb(233, 176, 227)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--pink-dark</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(173, 69, 163)"
                ></span>
                <code>rgb(173, 69, 163)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--red-light</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(239, 213, 213)"
                ></span>
                <code>rgb(239, 213, 213)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--red</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span
                  class="color"
                  style="background: rgb(252, 166, 166)"
                ></span>
                <code>rgb(252, 166, 166)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--red-dark</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background: rgb(173, 45, 45)"></span>
                <code>rgb(173, 45, 45)</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--text-color</code>
            </td>
            <td>
              <div class="doc-color-wrp">
                <span class="color" style="background: #000"></span>
                <code>#4a4a4a</code>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <code style="white-space: nowrap;">--font-family</code>
            </td>
            <td>
              <code
                >BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
                Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
                Helvetica, Arial, sans-serif</code
              >
            </td>
          </tr>
          <tr>
            <td>
              <code>--border-color</code>
            </td>
            <td>
              <code>var(--black)</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>--disabled-border-color</code>
            </td>
            <td>
              <code>var(--gray)</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>--border-width</code>
            </td>
            <td>
              <code>2px</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>--border-radius</code>
            </td>
            <td>
              <code>4px</code>
            </td>
          </tr>

          <tr>
            <td>
              <code>--shadow-bg</code>
            </td>
            <td>
              <code>var(--gray)</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>--shadow-distance</code>
            </td>
            <td>
              <code>3px</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>--focus-box-shadow-color</code>
            </td>
            <td>
              <code>var(--shadow-bg)</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>--focus-box-shadow-width</code>
            </td>
            <td>
              <code>2px</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>--transition</code>
            </td>
            <td>
              <code>0.15s cubic-bezier(0.64, 0.57, 0.67, 1.53)</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>--transition-liner</code>
            </td>
            <td>
              <code>0.15s linear</code>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3 class="size-4 fw-600 doc-section-title">
      What are global variables?
    </h3>
    <p>
      Global variables & classes are used in more than one element or component.
      If you change it on ':root', like this:
    </p>
    <Snippet :_code="customPropertyOnRoot" :only-code="true" />
    <p>
      it will affect more than one element. So you should be careful if you
      write customzations on ':root'. But if you change it in a specific class,
      it will affect only it. Like that:
    </p>
    <Snippet :_code="customPropertyInAClass" :only-code="true" />
  </div>
</template>

<script>
import { homeMixin } from './../snippets/home'
export default {
  mixins: [homeMixin]
}
</script>
